<template>
  <div v-if="!initLoadComplete" class="loader">
    <div class="loader__con">
      <div class="loader__bg">
        <div class="loader__img" v-bind:style="{height: `${loadSize/totalSize*100}%`}" ></div>
        <div v-if="!isMobile" class="loader__txt" v-html="$t('loader.txt')"></div>
      </div>

    </div>

    <FrameBook></FrameBook>
  </div>
</template>

<script>

  import promokit from '../utils/promokit';
  import {mapState, mapMutations} from 'vuex';
 import FrameBook from '@/components/FrameBook';

  export default {
    components: {FrameBook},
    data() {
      return {
        images:[],
        loadSize: 0,
        totalSize: 0,
        isMobile:promokit.util.isMobile(),
      };
    },
    computed: {
      ...mapState([
        'initLoadComplete',
        'contentsData'
      ])
    },
    methods: {
      ...mapMutations([
        'setInitLoadComplete'
      ]),
      detectImage() {
        let baseURL = promokit.util.getStaticPath(promokit.util.getNetwork())+'/promo/lineagew/teasing/2nd/img/';
        const isMobile  = promokit.util.isMobile();
        if(promokit.util.getNetwork() == 'file') baseURL = 'img/';
        this.images = [
          baseURL+'bg_cover.png',
          baseURL+'bg_cover2.png',
          baseURL+'btn_share.png',
          baseURL+'btn-pause.png',
          baseURL+'btn-play.png',
          baseURL+'icon_back.png',
          baseURL+'icon_down_ef.png',
          baseURL+'icon_down.png',
          baseURL+'icon_ef.png',
          baseURL+'icon_menu_close.png',
          baseURL+'icon_menu.png',
          baseURL+'icon_slick_arrow.png',
          baseURL+'icon_slick_dot.png',
          baseURL+'icon_view.png',
          baseURL+'icon_x.png',
          baseURL+'index_logo_ef.png',
          baseURL+'index_logo.png',
          baseURL+'lang_bg.png',
          baseURL+'lang_txt.png',
          baseURL+'share_bg.png',
          baseURL+'tit_bg.png',
          baseURL+'share_bg.png',
          baseURL+'share_bg.png',
        ]
        if(isMobile){
          this.images.push(baseURL+'paradigm_bg1_m.png')
          this.images.push(baseURL+'paradigm_bg3_m.png')
          this.images.push(baseURL+'paradigm_bg4_m.png')
          this.images.push(baseURL+'paradigm_bg2_m.png')
          this.images.push(baseURL+'bg_cover_m.png')
          this.images.push(baseURL+'bg_book_l_m.png')
          this.images.push(baseURL+'bg_book_r_m.png')
          this.images.push(baseURL+'clip_m_1.jpg')
          this.images.push(baseURL+'clip_m_2.jpg')
          this.images.push(baseURL+'clip_m_3_1.jpg')
          this.images.push(baseURL+'clip_m_3_2.jpg')
          this.images.push(baseURL+'clip_m_4.jpg')
          this.images.push(baseURL+'clip_m_5.jpg')
          this.images.push(baseURL+'navi_full_bg_m.jpg')
          this.images.push(baseURL+'icon_story.png')
        }else{
          this.images.push(baseURL+'paradigm_bg1.png')
          this.images.push(baseURL+'paradigm_bg3.png')
          this.images.push(baseURL+'paradigm_bg4.png')
          this.images.push(baseURL+'paradigm_chatting_img_en.png')
          this.images.push(baseURL+'paradigm_chatting_img_zh.png')
          this.images.push(baseURL+'paradigm_chatting_img_ja.png')
          this.images.push(baseURL+'paradigm_chatting_img_ko.png')
          this.images.push(baseURL+'clip_1.jpg')
          this.images.push(baseURL+'clip_2.jpg')
          this.images.push(baseURL+'clip_3.jpg')
          this.images.push(baseURL+'clip_4.jpg')
          this.images.push(baseURL+'clip_5.jpg')
          this.images.push(baseURL+'btn_showcase_pc_ja.png')
          this.images.push(baseURL+'btn_showcase_pc_zh.png')
          this.images.push(baseURL+'btn_showcase_pc_en.png')
          this.images.push(baseURL+'btn_showcase_pc_ko.png')
          this.images.push(baseURL+'paradigm_bg2.png')
          this.images.push(baseURL+'purple_title_bg.png')
          this.images.push(baseURL+'bg_book_l.png')
          this.images.push(baseURL+'bg_book_r.png')
          this.images.push(baseURL+'navi_full_bg.jpg')
        }

        // _.forEach(this.getContentsData, (l) => {
        //   _.forEach(l, (l) => {
        //     if(l.img)this.images.push(l.img);
        //   })
        // })
        // _.forEach($('*'), (el) => {
        //   if ($(el)[0].tagName.toLowerCase() === 'img') {
        //     let url = promokit.util.trim($(el).attr('src'), true);
        //
        //     if (!!url && _.indexOf(this.images, url) < 0) {
        //       this.images.push(url);
        //     }
        //   }
        //   else {
        //     let bg = $(el).css('background-image');
        //     if ((bg !== 'none') && (!/linear-gradient/.test(bg)) && (!/data:/.test(bg))) {
        //       let url = bg.slice(4, -1).replace(/"/g, '');
        //       if (_.indexOf(this.images, url) < 0) {
        //         this.images.push(url);
        //       }
        //     }
        //   }
        // });
        this.totalSize = this.images.length;
      },
      handleLoadingComplete(){
        this.setInitLoadComplete(true)
      },
      update() {
        let draw = () => {
          if (this.totalSize <= this.loadSize) {
            animationId.stop();
            this.handleLoadingComplete();
          }
          else {

          }
        };

        let animationId = promokit.util.animationFrame(draw);
        animationId.start();
      },
      loadFile() {
        if (this.images < 1) return;

        _.forEach(this.images, (item) => {
          new ImageLoader(item, this);
        });
      },
      onSuccess(count, msg) {
        this.loadSize++;
      },

      onFail(type, msg) {
        this.loadSize++;
      }
    },
    mounted() {
      this.detectImage();
      this.update();
      this.loadFile();
    }
  }

  class ImageLoader {
    constructor(url, props) {
      this.props = props;

      const img = new Image();
      img.src = url;

      img.onload = () => this.props.onSuccess(1, 'image', `success: ${url}`);
      img.onerror = () => this.props.onFail('image', `fail: ${url}`);
    }
  }
</script>

<style lang="scss">
  .loader {
    @include position($position:fixed, $width:100%, $height:100%, $left:0, $top:0);
    background:#000;
    z-index: 99999;
    &__con{
      @include position($position:absolute,  $left:50%, $top:50%);
      margin-top:-100px
    }
    &__bg{
        @include position($position:absolute, $top:0px, $left:50%, $width:366px, $height:88px);
        @include bg($bg: '../assets/img/loader_bg.png', $cover:cover);
    }
    &__img{
        @include position($position:absolute, $bottom:0px, $left:0, $width:100%, $height:88px);
        @include bg($bg: '../assets/img/loader_img.png', $cover:cover);
        background-position: 0 100%;
    }
    &__txt{
      margin-top:110px;
      text-align: center;
      font-size:14px;
      color:#6e6d67;

    }
    @include bp(mobile) {
      &__con{
        margin-top:-50px
      }
      &__bg{
        @include position($position:absolute, $top:0px, $left:50%, $width:366px * 0.5, $height:88px* 0.5);
      }
      &__img{
        @include position($position:absolute, $bottom:0px, $left:0, $width:100%, $height:88px* 0.5);
      }
    }
  }
</style>


